import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { NotFoundComponent } from './pages/errors/not-found/not-found.component';

export const routes: Routes = [
  { path: '', loadChildren: 'app/pages/login/login.module#LoginModule' },
  //{ path: '', redirectTo: 'pages', pathMatch: 'full' }, //ANTHONY redirects to health page by default
  { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule' },
  { path: 'login', loadChildren: 'app/pages/login/login.module#LoginModule' },
  { path: 'landing', loadChildren: 'app/pages/landing/landing.module#LandingModule' },
  { path: 'register', loadChildren: 'app/pages/register/register.module#RegisterModule' },
  { path: 'aboutglow', loadChildren: 'app/pages/aboutglow/aboutglow.module#AboutGlowModule' },
  { path: 'license', loadChildren: 'app/pages/aboutglow/license.module#LicenseModule' },
  { path: 'terms', loadChildren: 'app/pages/aboutglow/terms.module#TermsModule' },
  { path: 'aboutgridlab', loadChildren: 'app/pages/aboutgridlab/aboutgridlab.module#AboutGridLabModule' },
  { path: 'abouthitachi', loadChildren: 'app/pages/abouthitachi/abouthitachi.module#AboutHitachiModule' },
  { path: 'registration', loadChildren: 'app/pages/registration/registration.module#RegistrationModule' },
  { path: 'requestpassword', loadChildren: 'app/pages/requestpassword/requestpassword.module#RequestPasswordModule' },
  { path: 'samplenonloginpage', loadChildren: 'app/pages/samplenonloginpage/samplenonloginpage.module#SampleNonLoginPageModule' },
  { path: 'tutorial', loadChildren: 'app/pages/tutorial/tutorial.module#TutorialModule' },
  { path: 'blogposts', loadChildren: 'app/pages/blogposts/blogposts.module#BlogPostsModule' },
  { path: '**', component: NotFoundComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
   // useHash: true
});



// WEBPACK FOOTER //
// C:/angular/glow/src/app/app.routing.ts